import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { addWindow } from "actions";
import {
    Room,
    Style,
    Size,
    Design,
    Colour,
    Handle,
    Efficiency
} from "./WindowForm";
import { StepHistory } from "components/Steps";
import Logo from "components/Logo";
import Cart from "components/Cart";
import ReactCSSTransitionReplace from "react-css-transition-replace";

import "css/WindowPage.css";
import { emptyPreviousPreviews } from "./../actions";

class WindowPage extends Component {
    constructor(props) {
        super(props);
        this.nextPage = this.nextPage.bind(this);
        this.previousPage = this.previousPage.bind(this);
        this.setDesign = this.setDesign.bind(this);
        this.FormList = [
            Room,
            Style,
            Size,
            Design,
            Colour,
            Handle,
            Efficiency
        ];
        this.state = {
            page: 0,
            selectedDesign: {}
        };
    }

    getFormList() {
        let formList = [
            Room,
            Style,
            Size,
            Design,
            Colour,

        ];

        if (this.state.selectedDesign.openingsCount !== 0)
            formList.push(Handle);

        if (!this.props.IsEfficiencySelected)
            formList.push(Efficiency);

        return formList;
    }

    componentDidMount() {
        this.props.emptyPreviousPreviews();
    }

    setDesign(selectedDesign) {
        this.setState({ selectedDesign });
    }

    nextPage() {
        this.setState({
            page: this.state.page + 1
        });
    }

    previousPage() {
        this.setState({
            page: this.state.page - 1
        });
    }

    changePage(newPage) {
        this.setState({ page: newPage });
    }

    handleSubmit(values) {
        // call action creator to create this item and go to summary
        this.props.addWindow(values);

        this.props.history.push("/Summary");
    }

    render() {
        const { page } = this.state;

        let properties = {
            setDesign: this.setDesign
        };

        if (page !== 0) {
            properties.previousPage = this.previousPage;
        }

        if (page === this.getFormList().length - 1) {
            properties.onSubmit = this.handleSubmit.bind(this);
        } else {
            properties.onSubmit = this.nextPage;
        }

        let Step = this.getFormList()[page];

        window.dataLayer.push({
            event: "VirtualPageView",
            "VirtualPageURL": this.props.location.pathname + "/" + Step.name
        });

        return (
            <div className="WindowPage">
                <Logo topLeft={true} hideTextOnSmall={true} />
                <Cart />
                <StepHistory StepList={this.getFormList()} StepIndex={this.state.page} onStepClick={this.changePage.bind(this)} />
                <ReactCSSTransitionReplace
                    transitionName={"page"}
                    transitionEnterTimeout={2000}
                    transitionLeaveTimeout={1000}
                    className="transition-container">
                    <Step.form key={Step.name} {...properties} />
                </ReactCSSTransitionReplace>
            </div>
        );
    }
}

const mapStateToProps = state => {
    let IsEfficiencySelected = state.ProductList.filter(p => p.ItemType.Name === "Window").length > 0;

    return { IsEfficiencySelected };
};

export default withRouter(connect(mapStateToProps, { addWindow, emptyPreviousPreviews })(WindowPage));



// WEBPACK FOOTER //
// ./src/containers/WindowPage.js